import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { getAppTimezone } from './timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

/** Toolbar end date default: today at 23:59:59 in the app timezone. */
export const getDefaultToolbarEndDate = () =>
    dayjs()
        .tz(getAppTimezone())
        .hour(23)
        .minute(59)
        .second(59)
        .millisecond(0);

/** Keep the calendar date from the picker in the app timezone (start of day). */
export const normalizeToolbarStartDate = date => {
    if (!date || !dayjs(date).isValid()) {
        return null;
    }
    return dayjs(date).tz(getAppTimezone(), true).startOf('day');
};

/** Keep the calendar date from the picker, ending at 23:59:59 in the app timezone. */
export const normalizeToolbarEndDate = date => {
    if (!date || !dayjs(date).isValid()) {
        return null;
    }
    return dayjs(date)
        .tz(getAppTimezone(), true)
        .hour(23)
        .minute(59)
        .second(59)
        .millisecond(0);
};

/** Format a toolbar picker value as YYYY-MM-DD for API date path segments. */
export const formatToolbarDateForApi = date => {
    if (!date || !dayjs(date).isValid()) {
        return null;
    }
    return dayjs(date).tz(getAppTimezone(), true).format('YYYY-MM-DD');
};
